import React, { useSearchParams, useState } from 'react';
import Navbar from '../../components/Navbar';
import { Button, Form, Input, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { resetPassword } from '../../utils/api';

const ResetPassword = () => {
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    console.log('Success:', values);
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get('token');
    console.log({ token });
    try {
      const res = await resetPassword(token, values);
      window.location.replace(window.location.origin);
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        'Oops! Error while trying to reset password!';
      message.open({
        type: 'error',
        content: msg,
      });
    } finally {
      setLoading(false);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <div id='resetpassword' className='bg-primaryBlue h-screen flex flex-col'>
      <Navbar />
      <div className='flex flex-1 px-[40px]'>
        <div className='w-1/2 flex justify-center items-center'>
          <img src='/images/landing_page.svg' alt='' className='h-[600px]' />
        </div>
        <div className='w-1/2 flex justify-center items-center'>
          <Form
            layout='vertical'
            name='basic'
            labelCol={{
              span: 20,
            }}
            wrapperCol={{
              span: 24,
            }}
            style={{
              width: 250,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete='off'
          >
            <Form.Item
              name='new_password'
              label='New Password:'
              rules={[
                {
                  required: true,
                  message: 'Please input your password!',
                },
                {
                  min: 8,
                  message: 'Password must have a minimum length of 8',
                },
                {
                  pattern: new RegExp(
                    '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&_^#])[A-Za-z\\d@$!%*?&_^#(){}<>]{8,}$'
                  ),
                  message:
                    'Password must contain at least one lowercase letter, uppercase letter, number, and special character',
                },
              ]}
              hasFeedback
            >
              <Input.Password />
            </Form.Item>

            <Form.Item
              name='confirm_password'
              label='Confirm Password:'
              dependencies={['new_password']}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: 'Please confirm your password!',
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('new_password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Passwords do not match!'));
                  },
                }),
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              wrapperCol={{
                offset: 8,
                span: 16,
              }}
            >
              <Button
                type='primary'
                htmlType='submit'
                className='border-white bg-transparent w-[80px]'
                disabled={loading}
              >
                {loading ? <LoadingOutlined /> : 'Submit'}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
